import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Skeleton from '../Skeleton/Skeleton';
import { withRouter } from 'react-router-dom';
import { REQUEST_FORMS_DATA } from '../../actions/formsActions';

const mapStateToProps = state => {
  return {
    formsData: state.formsData
  }
};

const mapDispatchToProps = dispatch => ({
  getFormsData: () => dispatch({ type: REQUEST_FORMS_DATA })
});

class FormAssembly extends Component {

  formData = null;

  componentDidMount() {
    if (!this.props.formsData.forms) {
      this.props.getFormsData();
    }
  };

  getIFrameResizeScript = () => {
    const scriptTag = document.createElement('script');
    scriptTag.type = 'text/javascript';
    scriptTag.src = 'https://swacargo.tfaforms.net/js/iframe_resize_helper.js';
    return scriptTag;
  };

  render() {
    if (!this.props.formsData.forms) {

      return (<Skeleton type="IFRAME" />)
    } else {
      this.formData = this.props.formsData.forms.find((form) => {
        return this.props.formReferenceName === form.formReferenceName;
      });
      const iFrameResizeScript = this.getIFrameResizeScript();
      document.querySelector('body').appendChild(iFrameResizeScript);

      const isProduction = window.location.hostname.includes('swacargo.com');
      const urlQueryParms = "?&tfa_2919=" +  this.props.tfa2919 + "&tfa_3957=" +this.props.tfa3957 + "&tfa_3961=" +this.props.tfa3961;
      const iframeProdUrl =   this.formData.iframeUrl.prod + urlQueryParms;
      const iframeQAdUrl =   this.formData.iframeUrl.qa + urlQueryParms;

      return (<div style={{width: "100%", position: "relative"}}>
            <iframe width="100%" title={this.formData.title} src={ isProduction ? iframeProdUrl: iframeQAdUrl} />
      </div>)

    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FormAssembly));

FormAssembly.propTypes = {
  formReferenceName: PropTypes.oneOf([
    "CONTACT_FORM",
    "REQUEST_AIR_WAYBILL_NUMBER_FORM",
    "ACCOUNT_APPLICATION_FORM",
    "UPDATE_ACCOUNT_FORM",
    "ADDITIONAL_LOCATION_REQUEST_FORM",
    "EMAIL_PREFERENCE_FORM",
    "SERVICE_FAILURE_FORM",
    "LOST_OR_DAMAGED_CLAIM_FORM",
    "ONLINE_BOOKING_FORM",
    "BILLING_AND_INVOICING_FORM"
  ])
};




// WEBPACK FOOTER //
// ./src/components/FormAssembly/FormAssembly.js